<template>
  <el-dialog
    :title="DialogFormData.dialogTitle"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="650px"
    :close-on-click-modal="false"
    :before-close="Hide"
    :append-to-body="true"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row>
        <el-col>
          <el-form-item :label="l('描述')" prop="comment">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.comment"
              :placeholder="l('请输入') + l('描述')"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="DialogFormData.permit_img">
          <ResourceListUpLoad
            :label="l('图片补充')"
            file_type="image"
            usage="admin"
            :initResourceUrl.sync="DialogFormData.img_arr"
          />
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button type="primary" @click="submitForm"
        >{{l("确 定")}}</el-button
      >
      <slot :Hide="Hide" :id="DialogFormData.id"></slot>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "RejectDialog",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        dialogTitle: this.l("下架"), //模态框标题

        //用于接口回传的信息
        id: "",
        comment: "",
        img_arr: [],

        confirm_tip: "", //提交时是否需要提示信息
        permit_img: "", //是否允许上传补充图片
      },
      dialogRules: {
        comment: [{ required: true, message: this.l("请输入") + this.l("描述"), trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        if (this.DialogFormData.confirm_tip) {
          this.$confirm(this.DialogFormData.confirm_tip, "", {
            type: "warning",
          }).then(() => {
            this.$emit("submitDialog", this.DialogFormData);
            this.Hide();
          });
        } else {
          this.$emit("submitDialog", this.DialogFormData);
          this.Hide();
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

